class EmailForm {
	LIST_ID = 'X4U3Um';
	KL_SITE_ID = 'Rxzgif';
	REVISION = '2025-07-15';
	constructor() {
		this.form = document.getElementById('configEmailForm');
		this.errorMessage = document.querySelector('.configurator-email-form__error-message');
		this.successMessage = document.querySelector('.configurator-email-form__success-message');
		this.urlSuccessMessage = document.querySelector('.configurator-email-form__share-url-success');
		this.shareButton = document.querySelector('.copy-button');
		this.resetShelfSizesButtons = document.querySelectorAll('[reset-shelf-sizes]');
		this.parentElement = document.querySelector('shelf-configurator');
		this.shelfForm = this.parentElement.querySelector('shelf-form');
		if (!this.form) {
			console.error('Email form not found');
			return;
		}
		this.init();
	}

	init() {
		this.form.addEventListener('submit', this.handleSubmit.bind(this));
		this.shareButton.addEventListener('click', this.shareConfiguratorUrl.bind(this));
		this.resetShelfSizesButtons.forEach(button => {
			button.addEventListener('click', this.hideForm.bind(this));
		});
		this.shelfForm.addEventListener('shelf-form:set-up', this.showEmailForm.bind(this));
	}

	setHiddenUrlInput() {
		const configuratorSearchParams = this.parentElement.generateUrlParams();
		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.set('shelf', configuratorSearchParams.get('shelf'));
		this.form.elements.configurator_url.value = currentUrl.toString();
	}

	shareConfiguratorUrl(event) {
		event.preventDefault();
		this.setHiddenUrlInput();
		if (!this.form.elements.configurator_url.value) {
			return;
		}
		const configuratorUrl = this.form.elements.configurator_url.value;
		if (configuratorUrl) {
			navigator.clipboard
				.writeText(configuratorUrl)
				.then(() => {
					this.showUrlCopySuccessMessage();
				})
				.catch((err) => {
					console.error('Could not copy text: ', err);
				});
		} else {
			console.error('Configurator URL is empty.');
		}
	}

	async triggerEventForMetricsChange(email, firstName, configuratorUrl) {
		const payload = {
			data: {
				type: 'event',
				attributes: {
					time: new Date().toISOString(),
					unique_id: crypto.randomUUID(),
					properties: {
						action: 'configurator_set_url',
						configurator_url: configuratorUrl,
					},
					metric: {
						data: {
							type: 'metric',
							attributes: {
								name: 'Configurator URL Set',
							},
						},
					},
					profile: {
						data: {
							type: 'profile',
							attributes: {
								email: email,
								first_name: firstName,
							},
						},
					},
				},
			},
		};

		try {
			const res = await fetch(`https://a.klaviyo.com/client/events/?company_id=${this.KL_SITE_ID}`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					revision: this.REVISION,
				},
				body: JSON.stringify(payload),
			});
			if (res.ok) {
				// console.log('Event triggered successfully', res);
			} else {
				console.error('Failed to trigger event:', res);
			}
		} catch (error) {
			console.error('Error triggering event:', error);
		}
	}

	async handleSubmit(event) {
		event.preventDefault();
		this.setHiddenUrlInput();
		if (!this.form.elements.email.value) {
			this.showErrorMessage();
			return;
		}
		const email = this.form.elements.email.value;
		const firstName = this.form.elements.first_name.value;
		const configuratorUrl = this.form.elements.configurator_url.value;

		if (email && configuratorUrl) {
			// console.log('Email:', email);
			// console.log('First Name:', firstName);
			// console.log('Configurator URL:', configuratorUrl);
			const payload = {
				data: {
					type: 'subscription',
					attributes: {
						profile: {
							data: {
								type: 'profile',
								attributes: {
									email: email,
									first_name: firstName,
									properties: {
										configurator_url: configuratorUrl,
									},
								},
							},
						},
						custom_source: 'share-page-form',
					},
					relationships: {
						list: { data: { type: 'list', id: this.LIST_ID } },
					},
				},
			};

			try {
				const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.KL_SITE_ID}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						revision: this.REVISION,
					},
					body: JSON.stringify(payload),
				});
				if (res.ok) {
					this.showSuccessMessage();
					this.triggerEventForMetricsChange(email, firstName, configuratorUrl);
				} else {
					this.showErrorMessage();
				}
			} catch (error) {
				console.error('Error sending email:', error);
				this.showErrorMessage();
			}
		}
	}

	showErrorMessage() {
		this.errorMessage.style.display = 'block';
		this.successMessage.style.display = 'none';
	}

	showSuccessMessage() {
		this.successMessage.style.display = 'block';
		this.errorMessage.style.display = 'none';
	}

	showUrlCopySuccessMessage() {
		this.urlSuccessMessage.style.display = 'block';
	}

	hideMessages() {
		this.errorMessage.style.display = 'none';
		this.successMessage.style.display = 'none';
		this.urlSuccessMessage.style.display = 'none';
	}

	showEmailForm() {
		// console.log('EmailForm: Showing email form');
		this.form.parentElement.classList.remove('hidden');
	}

	hideForm() {
		this.hideMessages();
		this.form.parentElement.classList.add('hidden');
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const emailForm = new EmailForm();
});
